module.exports = __webpack_public_path__ + "img/manta.765b9769.png";